import { useRealTimeCoins, useRealtimeBalanceUpdate } from "hooks";
export var GlobalDataEngine = function () {
    useRealTimeCoins();
    useRealtimeBalanceUpdate();
    return null;
};
export default GlobalDataEngine;
